import nextApi from "./next-api";

const getWebinars = () => {
  return nextApi.get(`cms/webinars`);
};

const createWebinar = (data) => {
  return nextApi.post(`cms/webinars`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateWebinar = (id, data) => {
  return nextApi.put(`cms/webinars?id=${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteWebinar = (id) => {
  return nextApi.delete(`cms/webinars?id=${id}`);
};

const WebinarService = {
  getWebinars,
  createWebinar,
  updateWebinar,
  deleteWebinar,
};
export default WebinarService;
